import fp from 'lodash/fp';
import React from 'react';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { branch, lifecycle, mapProps, renderComponent, withProps } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { routes } from '../../../../constants';
import { adminActions } from '../../../../state/modules/admin';
import Loading from '../../loading';
import teamProgressReport from '../../shared/team-progress-report';

const reportBreadCrumb =
  <Breadcrumb>
    <LinkContainer to={routes.adminPortal.root}>
      <BreadcrumbItem>
        Admin portal
      </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Progress Report
        </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = (state) => ({
  businessReport: state.admin.businessReport
})

const mapDispatchToProps = (dispatch) => ({
  getBusinessReport: bindActionCreators(adminActions.admin.getBusinessReport, dispatch)
})

export default compose(
  withProps(({
    match: {
      params: {
        business,
        yearsFromNow
      }
    }
  }) => ({
    businessId: parseInt(business, 10),
    yearsFromNow: parseInt(yearsFromNow, 10)
  })),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        getBusinessReport,
        businessId,
        yearsFromNow
      } = this.props;

      getBusinessReport(businessId, yearsFromNow);
    }
  }),
  branch(
    ({ businessReport }) => !businessReport,
    renderComponent(Loading)
  ),
  withProps(() => ({
    reportBreadCrumb
  })),
  mapProps(
    ({ businessReport, businessId, yearsFromNow }) => ({
      businessId,
      afsLicence: businessReport.afsLicence,
      business: businessReport.business,
      businessTeamsWithStats: businessReport.businessTeamsWithStats,
      reportBreadCrumb,
      defaultProgressLabel: fp.flow(
        fp.get('industries'),
        fp.first,
        fp.getOr('CPD Progress')('defaultProgressLabel')
      )(businessReport),
      downloadBusinessActivityFor: 'adminWithYearsOffset',
      yearsFromNow
    })
  )
)(teamProgressReport)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/user-portal/business-progress-report.js